import isHotkey from 'is-hotkey';

export const isSelectAllHotkey = isHotkey('mod+a');
export const isSaveHotkey = isHotkey('mod+s');
export const isMaxWidthHotkey = isHotkey('mod+shift+e');
export const isResizeHotkey = isHotkey('mod+e');
export const isXRayHotkey = isHotkey('mod+k');
export const isDeleteHotKey = isHotkey('mod+backspace');
export const isDuplicateHotKey = isHotkey('mod+d');
export const isCopyHotKey = isHotkey('mod+c');
export const isHighlightHotKey = isHotkey('mod+shift+h');
export const isCmdEnterHotkey = isHotkey('mod+enter');
export const isDownHotKey = isHotkey('down');
export const isUpHotKey = isHotkey('up');
export const isUndoHotKey = isHotkey('mod+z');
export const isRedoHotKey = isHotkey('mod+shift+z');
